import { TypeOptionsFilterTemplate } from '../../../components/tableTemplates/TestAndSourceFilterTemplate'
import { ControlInformation } from '../../../data/models/_generatedUblInvoice'

export type TestAndSourceFilter = TypeOptionsFilterTemplate['value'] | null

export const testAndSourceFilterService = (
  trialFlag: ControlInformation['trialFlag'],
  processingType: ControlInformation['processingType'],
  filter: TestAndSourceFilter,
) => {
  if (!filter) return true

  switch (filter) {
    case 'test':
      return trialFlag === true
    case 'web':
      return processingType === 'WEB' && trialFlag !== true
    case 'mail':
      return (
        processingType != null && processingType !== 'WEB' && trialFlag !== true
      )
    default:
      return true
  }
}
